import { Modal } from '../../components/Modal';
import { ModalOverlay } from '../../components/ModalOverlay';
import { ExperienceType } from '../../atoms';
import ImageTargetIcon from '../onboarding/assets/image-target-icon.svg';
import ARIcon from '../onboarding/assets/ar-icon.webp';
import PlayHeader from '../onboarding/assets/play-header.svg';
import ScanHeader from '../onboarding/assets/scan-header.svg';

type InfoModalProps = {
    mode: ExperienceType;
    onClose: () => void;
};

export const InfoModal = ({ mode, onClose }: InfoModalProps) => {
    return (
        <ModalOverlay>
            <Modal
                maxWidth="max-w-[390px]"
                maxHeight="max-h-[540px]"
                className="bg-[#BD728C] bg-cover text-white centered w-[92%] rounded-none z-[999]"
            >
                <div className="flex flex-col h-full justify-between px-[30px] py-10 pb-16">
                    <div className="flex flex-col flex-grow h-full justify-start gap-[30px]">
                        {mode === ExperienceType.IMAGES && (
                            <>
                                <img
                                    src={ImageTargetIcon}
                                    className="max-w-[184px] w-full self-start"
                                />
                                <img
                                    src={ScanHeader}
                                    className="w-[76%] self-start"
                                />
                                <p className="text-lg font-mark-pro-xtralite leading-[110%]">
                                    To unlock the immersive musical and
                                    visual adventure behind each artwork,
                                    point your camera at any of the
                                    captivating pieces nearby and watch them
                                    come to life with augmented reality.
                                </p>
                            </>
                        )}
                        {mode === ExperienceType.MODEL && (
                            <>
                                <img
                                    src={ARIcon}
                                    className="max-w-[240px] w-full self-start"
                                />
                                <img
                                    src={PlayHeader}
                                    className="w-[76%] self-start"
                                />
                                <p className="text-lg font-mark-pro-xtralite leading-[125%]">
                                    You are about to view an augmented reality sculpture. Please follow the next step to position the experience.
                                </p>
                            </>
                        )}
                    </div>
                    <button
                        className="button-default mx-auto"
                        onClick={onClose}
                    >
                        OK
                    </button>
                </div>
            </Modal>
        </ModalOverlay>
    );
};
